import { Dialog, DialogActions, DialogContent, InputBase } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import React from 'react';
import GhostButton from '../../shared/button/GhostButton';
import { Subheading } from '../../shared/typography/PrimaryTypography';

/**
 * A modal displaying an expanded text input for long qualitative Metric Record values.
 * @param {boolean} open The display state of the modal.
 * @param {string | number | undefined} value The metric record value of the text input.
 * @param {string} title The title (metric name) of the modal.
 * @param {void} handleChange Handler function to update the text value in the parent edit component
 * @param {void} handleCloseModal Handler function to close the modal
 * @returns {JSX.Element}
 */
const ExpandValueEditModal = ({
  open,
  value,
  title,
  handleChange,
  handleCloseModal
}: {
  open: boolean;
  value?: string | number;
  title: string;
  handleChange: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  handleCloseModal: () => void;
}) => {
  return (
    <Dialog open={open} onClose={handleCloseModal} fullWidth maxWidth="sm">
      <Subheading weight="Bold" sx={{ m: 2 }}>
        {title}
      </Subheading>
      <DialogContent>
        <InputBase
          multiline
          placeholder="Enter your comprehensive details here..."
          rows={20}
          value={value}
          sx={{
            width: '100%',
            fontSize: '0.9rem',
            py: 2,
            px: 2,
            border: '1px solid #7D8F99',
            borderRadius: 4,
            my: 2
          }}
          onChange={handleChange}
        />
        <DialogActions sx={{ mt: 4 }}>
          <GhostButton startIcon={<ArrowBackIosNewIcon />} onClick={handleCloseModal} dark>
            Back
          </GhostButton>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ExpandValueEditModal;
